// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js";
import { notificationMixins } from "@/app/mixins/modules/notification-mixins.js";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { dateMixins } from "@/app/mixins/utils/date-mixins";

// Event
import EventBus from "@/app/bus/event-bus";

// Services
import NotificationService from '@/app/services/main/notifications/notifications-service';

// Constant
import { NOTIFICATION_ICON, NOTIFICATION_TYPE } from "@/app/constants/notification-constants";
import { STATUS_CODES } from '@/app/constants/constants.js';


export default {
    name: "NotificationComponent",
    mixins: [tableMixins, notificationMixins, toastMessageMixins, dateMixins],
    props: {
        isDropdown: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            // loaders
            isAPILoading: false,
            desc: true,
        };
    },
    computed: {
        notificationList() {
            return this.isDropdown ? this.notificationListDropDown : this.notificationListPage;
        },
    },
    async created() {
        if (!this.isDropdown) {
            await this.getTableContent();
        }
        EventBus.$on("refreshNotification", this.refreshNotification);
    },
    beforeDestroy() {
        EventBus.$off("refreshNotification", this.refreshNotification);
    },
    methods: {
        async goToNotification(notification) {
            const { notificationTypeCode, targetId, read, status, referenceNumber, token, userId } = notification;

            if (!read) {
                this.markReadNotification(notification);
            }
            switch (notificationTypeCode) {
                case NOTIFICATION_TYPE.PET_ORDER:
                    if (status === "A") {
                        this.$router.push(`/dog-purchase/view/${targetId}`);
                    } else {
                        this.$router.push(`/dog-purchase/request/${targetId}`);
                    }
                    break;

                case NOTIFICATION_TYPE.PAID_ORDER:
                    this.$router.push(`/dog-orders/${targetId}/view`);
                    break;

                case NOTIFICATION_TYPE.PRODUCT:
                    this.$router.push(`/orders/${targetId}/view`);
                    break;

                case NOTIFICATION_TYPE.CONTACT_US:
                    const photo = require(`@/assets/images/_shared/notification-dog.png`);

                    this.$swal({
                        titleText: `A customer sent an inquiry to your email`,
                        html: `<div style="margin:2rem"><img src=${photo} style="" height="200"></div><br><p><strong>Kindly check your email to see the customer inquiry.</strong></p>`,
                        confirmButtonText: "Got it!",
                        reverseButtons: true,
                        showCloseButton: true,
                    });

                    break;

                case NOTIFICATION_TYPE.BREEDER:
                    this.$router.push(`/breeder-management/${targetId}/view`);
                    break;

                case NOTIFICATION_TYPE.PUPPY_SELL && NOTIFICATION_TYPE.PUPPY_PURCHASE:
                    this.$router.push(`/pet-purchases/puppy-selling/${targetId}/view`);
                    break;
                case NOTIFICATION_TYPE.ADM_USER_NOTES:
                    this.$router.push(`/users/user/${userId}`);
                    break;
            }
        },
        refreshNotification() {
            this.getNotificationList({ desc: this.desc });
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
            this.getNotificationList({ page, limit, sortBy, desc });
        },
        getNotificationList(queryParams) {
            this.setNotificationList({
                queryParams: queryParams,
                isPage: !this.isDropdown,
            });
        },
        getIcon({ notificationTypeCode }) {
            const notificationIcon = NOTIFICATION_ICON[notificationTypeCode];
            return require(`@/assets/images/_shared/${notificationIcon}`);
        },
        async markAllAsReadNotifications(e) {
            e.stopPropagation(); // prevents the bootstrap dropdown from closing

            return NotificationService.markAllAsReadNotifications().then(async (res) => {
                if (res.status !== STATUS_CODES.SUCCESS_NO_CONTENT) {
                    this.showGenericErrorToast();
                }
                else{
                    this.showCustomSuccessToast("Success!", "Your notifications have all been marked as read successfully.");
                    EventBus.$emit('refreshNotification');
                }
            });
        },
    },
};
